import Button from 'components/Button';
import Icon from 'components/Icon';
import {FC} from 'react';
import {t} from 'ttag';

type MagicLinkSuccessProps = {
    emailAddress: string;
};

const MagicLinkSuccess: FC<MagicLinkSuccessProps> = ({emailAddress}) => {
    return (
        <div>
            <h1 className="mt-2 flex">
                <Icon className="my-0.5 mr-2 text-green-500" icon="success" />
                {t`Please check your email`}
            </h1>
            <div className="pb-4 pt-2 sm:ml-8">
                <p className="mb-4">
                    {t`If a MakeLeaps user has a Business Portal set up for ${emailAddress}, you will receive a Login Link to that address in a few moments.`}
                </p>
                <div className="mb-4 flex">
                    <Icon
                        className="my-0.5 mr-2 text-gold-700"
                        icon="warning"
                        size="base"
                    />
                    {t`Login Links expire an hour after they are sent.`}
                </div>
                <p className="mb-2 text-sm text-grey-600">
                    {t`Didn't get an email?`}
                </p>
                <ul className="text-sm text-grey-600">
                    <li>{t`Confirm you typed your email address correctly.`}</li>
                    <li>{t`Check your email account's spam folder.`}</li>
                    <li>{t`Check your email server is not blocking emails from the makeleaps.com domain.`}</li>
                    <li>{t`Please check that your business partner has your email address and other Business Portal settings correct.`}</li>
                </ul>
            </div>
            <div className="mt-8 flex flex-row justify-end gap-4">
                <Button
                    aria-label="try-again"
                    className="border-transparent text-left text-green-700"
                    kind="custom"
                    onClick={() => window.history.back()}
                >
                    {t`Try Again`}
                </Button>
            </div>
        </div>
    );
};

export default MagicLinkSuccess;
